// Formatage d'un montant d'abonnement dans la devise réellement facturée (jamais de conversion)
const LOCALES = { fr: "fr-CH", en: "en-GB", de: "de-CH", it: "it-CH" };
const EUR_LOCALES = { fr: "fr-FR", en: "en-IE", de: "de-DE", it: "it-IT" };

export function formatMoney(amount, currency, lang = "fr") {
  if (amount == null || !currency) return "";
  try {
    return new Intl.NumberFormat(((currency || "").toLowerCase() === "eur" ? EUR_LOCALES[lang] : LOCALES[lang]) || "fr-CH", { style: "currency", currency: currency.toUpperCase(), minimumFractionDigits: 2 }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency.toUpperCase()}`;
  }
}

export function billingErrorKey(detail) {
  if (detail === "billing_country_required") return "billing_country_required";
  if (detail === "currency_mismatch") return "billing_currency_mismatch";
  if (detail === "price_unavailable_in_currency" || detail === "annual_disabled") return "billing_price_unavailable";
  if (detail === "store_subscription_active") return "billing_store_active";
  if (detail === "subscription_active") return "billing_already_subscribed";
  return null;
}
